import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createActionGroup, createFeature, createReducer, createSelector, on, props } from '@ngrx/store';
import { DrillSubjectInterface } from '../../+models';

export const NAME = 'drillSubjects';

export type State = EntityState<DrillSubjectInterface>;

export const adapter: EntityAdapter<DrillSubjectInterface> = createEntityAdapter<DrillSubjectInterface>();

export const initialState: State = adapter.getInitialState();

export const actions = createActionGroup({
  source: 'DrillSubjects',
  events: {
    'Upsert Drill Subjects': props<{ drillSubjects: DrillSubjectInterface[] }>(),
  },
});

export const feature = createFeature({
  name: NAME,
  reducer: createReducer(
    initialState,
    on(actions.upsertDrillSubjects, (state, { drillSubjects }): State => adapter.upsertMany(drillSubjects, state))
  ),
});

/**
 * Null-safe name lookup: returns an empty string while the drill subject
 * is not (yet) in the store, so route data (breadcrumbs) can't crash on it.
 *
 * Standalone props-selector: `createFeature`'s `extraSelectors` only accepts
 * single-argument selectors or selector factories.
 */
export const selectName = createSelector(
  feature.selectEntities,
  (entities, byId: { id: number }): string => entities[byId.id]?.name ?? ''
);
